import { useDispatch } from "react-redux";

// Actions
import { closeLandmarkNearbyForm } from "../../../actions/location-summary/LocationSummaryActions";

// Constants and Utils
import {
  FormDataTargets,
  LandmarksNearbyConstants,
} from "../../../constants/GeneralConstants";
import { downloadPdf } from "../../../common-utils/file-utils/PdfUtil";

/**
 * Landmarks Nearby Form
 */
export default function LandmarkNearbyForm({
  latitude,
  longitude,
  radius = 1000,
  mediaTitle = "",
  categorizedPointsMap = {},
}) {
  const dispatch = useDispatch();

  // distance in KM
  const distanceInKm = radius ? radius / 1000 : "1";

  // filename
  const fileName = `${mediaTitle}_LandmarksNearby_${distanceInKm}KM`;

  // functions
  async function downloadLandmarksNearby() {
    const input = document.getElementById("landmark-nearby");
    await downloadPdf(input, fileName);
  }

  return (
    <div
      className="modal fade"
      id={FormDataTargets.landmarkNearbyForm}
      data-backdrop="static"
    >
      <div className="modal-dialog modal-lg" role="document">
        <div className="modal-content">
          {/* Form Header */}
          <div className="modal-header bg-alt px-5 align-items-baseline">
            <h4 className="modal-title">Landmarks Nearby</h4>
            <div className="d-flex align-items-center">
              <button
                className="btn text-primary shadow-none mr-2"
                onClick={downloadLandmarksNearby}
              >
                Download PDF Report
              </button>
              <button
                type="button"
                className="btn btn-outline-primary px-3 rounded-lg shadow-none"
                data-dismiss="modal"
                onClick={() => dispatch(closeLandmarkNearbyForm())}
              >
                {"X"}
              </button>
            </div>
          </div>

          {/* Form body */}
          <div className="modal-body px-5 py-4" id="landmark-nearby">
            <h4 className="font-weight-bold">Landmarks</h4>
            <div className="">
              <h5 className="mb-1">
                Site Name: {mediaTitle ? mediaTitle : "--"}
              </h5>
              <h5 className="mb-1">
                Location (lat,lng): {latitude},{longitude}
              </h5>
              <h5>Distance: {distanceInKm} KM</h5>
            </div>
            <hr className="my-3" />

            {/* points */}
            {LandmarksNearbyConstants.map((landmark, i) => {
              const { label, key } = landmark;
              const points = categorizedPointsMap?.[key] || [];
              const pointsCount = points.length;

              return (
                <div key={i}>
                  <h6 className="font-weight-bold">
                    {label} ({pointsCount})
                  </h6>
                  <ul className="row row-cols-2">
                    {points.map((point) => {
                      const { id, name } = point;
                      return (
                        <li key={id} className="font-italic">
                          {name}
                        </li>
                      );
                    })}
                  </ul>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
